import axios from "axios";

import { store } from "../store";
const token = store.getters["getToken"];

// Request
axios.interceptors.request.use(
  (config) => {
    config.headers.Accept = "application/json";
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { axios as axiosApi };
